var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogomark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_639_7743)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "#4D61CD"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0V180",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 0V180",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 0V180",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 0V180",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0V180",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 0V180",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 0V180",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 0V180",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 0V180",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 0V180",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 0V180",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 0V180",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 0V180",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 0V180",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 168H180",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 156H180",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 144H180",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 132H180",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 120L180 120",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 108L180 108",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 96L180 96",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 84L180 84",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 72L180 72",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 60L180 60",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 48L180 48",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 36L180 36",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24L180 24",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12L180 12",
    stroke: "black",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_639_7743)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.576 38.4066C115.035 25.3444 98.2717 20.8528 85.2095 28.3942L38.4083 55.415C25.3461 62.9564 20.8545 79.7195 28.3959 92.7816C36.378 106.607 51.8479 106.202 65.4946 105.845L65.8698 105.835C79.0515 105.49 89.1312 105.832 95.0932 112.824L53.7487 136.694L55.4166 139.583C62.958 152.645 79.7211 157.137 92.7833 149.595C92.9768 149.483 93.1626 149.362 93.3527 149.247L93.3611 149.262L139.584 122.575C152.647 115.033 157.138 98.27 149.597 85.2078C141.592 71.3437 131.457 68.7822 117.698 69.1426L117.323 69.1519C104.142 69.4971 94.0676 69.1498 88.1049 62.1606L124.244 41.2956L122.576 38.4066Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6617 71.6518L69.9938 68.7629C64.2917 58.8867 51.6177 55.4902 41.7409 61.1926C31.8641 66.8949 28.4686 79.5692 34.1706 89.4454C39.7379 99.0882 50.5921 99.5609 65.3185 99.1746L65.6937 99.1653C79.3404 98.8077 94.8103 98.4028 102.792 112.228C106.92 119.378 107.435 127.633 104.921 134.881L136.245 116.796C146.122 111.094 149.518 98.4196 143.816 88.5434C138.113 78.6655 131.565 75.4531 117.868 75.8119L117.493 75.8212C104.834 76.153 90.6064 76.5264 82.2423 65.5432L79.7508 66.9816L71.6617 71.6518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.5449 34.1735L57.2314 52.2523C63.7321 53.5029 69.7523 57.0862 73.9309 62.6411L76.4177 61.2053L84.5068 56.5351L114.897 38.9893C108.599 31.2812 97.4383 29.0389 88.5449 34.1735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4504 118.586L63.0936 138.999C69.3906 146.707 80.5522 148.949 89.445 143.815C98.3384 138.681 101.978 127.893 98.4504 118.586Z",
    fill: "#C0C9F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7025 65.6426L32.3456 86.0559C28.8185 76.7483 32.4576 65.9611 41.3504 60.8268C50.2438 55.6922 61.4054 57.9342 67.7025 65.6426Z",
    fill: "#C0C9F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.6547,
    y: 96.2622,
    width: 11.25,
    height: 7.5,
    transform: "rotate(-30 41.6547 96.2622)",
    fill: "#F25CBE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1302,
    y: 103.491,
    width: 11.25,
    height: 7.5,
    transform: "rotate(-30 89.1302 103.491)",
    fill: "#F25CBE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.1398,
    y: 85.0122,
    width: 11.25,
    height: 7.5,
    transform: "rotate(-30 61.1398 85.0122)",
    fill: "#F25CBE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.616,
    y: 92.2412,
    width: 11.25,
    height: 7.5,
    transform: "rotate(-30 108.616 92.2412)",
    fill: "#F25CBE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.625,
    y: 73.7622,
    width: 11.25,
    height: 7.5,
    transform: "rotate(-30 80.625 73.7622)",
    fill: "#F25CBE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.102,
    y: 80.9912,
    width: 11.25,
    height: 7.5,
    transform: "rotate(-30 128.102 80.9912)",
    fill: "#F25CBE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_639_7743)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5065 56.5347L76.4174 61.2049L73.9306 62.6407C69.752 57.0858 63.7318 53.5025 57.2312 52.2519L88.5447 34.1731C97.438 29.0385 108.599 31.2808 114.897 38.9889L84.5065 56.5347ZM117.495 75.8225L117.87 75.8131C131.567 75.4543 138.115 78.6667 143.818 88.5447C149.52 98.4209 146.125 111.095 136.248 116.797L104.924 134.882C107.438 127.634 106.923 119.379 102.795 112.229C94.8128 98.404 79.3429 98.8089 65.6962 99.1665L65.321 99.1759C50.5946 99.5621 39.7404 99.0894 34.1731 89.4466C28.4711 79.5704 31.8666 66.8962 41.7434 61.1938C51.6202 55.4914 64.2942 58.8879 69.9963 68.7641L71.6642 71.6531L79.7533 66.9828L82.2448 65.5444C90.6089 76.5276 104.837 76.1543 117.495 75.8225ZM63.0946 139.002L98.4521 118.589C101.979 127.897 98.34 138.684 89.4466 143.818C80.5532 148.953 69.3922 146.71 63.0946 139.002ZM122.575 38.4075C115.034 25.3454 98.2709 20.8537 85.2088 28.3952L38.4075 55.4159C25.3454 62.9573 20.8537 79.7204 28.3952 92.7825C36.3773 106.608 51.8472 106.203 65.4939 105.845L65.869 105.836C79.0508 105.491 89.1304 105.833 95.0925 112.825L53.7479 136.695L55.4159 139.584C62.9573 152.646 79.7204 157.138 92.7825 149.596C92.9761 149.484 93.1619 149.363 93.352 149.248L93.3603 149.263L139.584 122.575C152.646 115.034 157.138 98.2709 149.596 85.2088C141.592 71.3446 131.456 68.7831 117.698 69.1435L117.322 69.1529C104.142 69.498 94.0669 69.1507 88.1041 62.1615L124.243 41.2965L122.575 38.4075Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_639_7743",
    x: 21.7366,
    y: 24.735,
    width: 134.52,
    height: 134.52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_639_7743"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_639_7743",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_639_7743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_639_7743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomark);
export default __webpack_public_path__ + "static/media/logomark.a623fadb1735259c1bc9d9b5783ef6da.svg";
export { ForwardRef as ReactComponent };